// Reeds: a small cluster of thin tall blades leaning at slightly different
// angles, a few tipped with a brown seed head. Ported 1:1 from age-of-mcp's
// classic reeds.ts, restoring its radial blade loop.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  const parts: Part[] = [];
  const N = 6;
  for (let i = 0; i < N; i++) {
    const a = (i / N) * Math.PI * 2;
    const lean = 0.12 + (i % 3) * 0.05;
    const hgt = 0.5 + (i % 2) * 0.18;
    parts.push({
      geometry: new THREE.CylinderGeometry(0.012, 0.02, hgt, 4),
      color: i % 2 ? "#6f9a46" : "#7faa50",
      position: [Math.cos(a) * 0.1, hgt / 2, Math.sin(a) * 0.1],
      rotation: [Math.sin(a) * lean, 0, -Math.cos(a) * lean],
    });
    if (i % 2 === 0) {
      parts.push({ geometry: new THREE.CylinderGeometry(0.03, 0.02, 0.12, 5),
        color: "#8a6a3e", position: [Math.cos(a) * 0.14, hgt, Math.sin(a) * 0.14] });
    }
  }
  return parts;
}

export const reeds = defineModel({
  id: "reeds",
  batchId: "standard",
  name: "Reeds",
  tags: ["scenery","reeds","low-poly","age-of-mcp","classic","water"],
  summary: "Low-poly reeds.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.3,
  parts: () => partsFor(),
  animations: [],
});
